<section id="privacy-policy-page-section">
    <app-navbar [includeCenterLinks]="false"></app-navbar>

    <div id="privacy-policy-page-section">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <h1 class="text-white">PI | Powell Industries Privacy Policy</h1>
                </div>

                <div class="col-lg-2">
                    <p class="text-secondary mb-0">Last Updated Date:</p>
                    <p class="text-secondary mb-0">Company Name(s):</p>
                    <p class="text-secondary mb-0">Company CEO:</p>
                    <p class="text-secondary mb-0">Company Address(es):</p>
                    <p class="text-secondary mb-0">Website / Platforms:</p>
                </div>

                <div class="col-lg-6">
                    <p class="mb-0">{{ lastUpdatedDate }}</p>
                    <p class="mb-0">Powell Industries Incorporated (S-Corporation)</p>
                    <p class="mb-0">Alanté Devon Powell</p>
                    <p class="mb-0">100 Piedmont Avenue NE Atlanta, GA 30303</p>
                    <p class="mb-0">PI | Portal, PI | Index, and related Powell Industries Services</p>
                </div>

                <div class="col-lg-12">
                    <button class="btn btn-outline-light mt-3">Receive a Copy Via E-mail</button>
                </div>
            </div>

            <div class="horizontal-decorator-line-secondary my-3"></div>

            <div class="row mt-3">
                <div class="col-lg-12">
                    <h3>The short version</h3>
                    <p>We respect your privacy.</p>
                    <p>We collect the information needed to provide our services, manage accounts, support customers, secure the platform, process billing, and improve the experience.</p>
                    <p>We do not sell your personal information. We do not build our business around stalking people across the internet. We do not want your data just to have it.</p>
                    <p>Your data is yours. Our job is to protect it, use it responsibly, and be honest about what we collect.</p>
                </div>

                <div class="horizontal-decorator-line-secondary my-3"></div>

                <div class="col-lg-12">
                    <h3>1. What this policy covers</h3>
                    <p>This Privacy Policy explains how Powell Industries collects, uses, stores, protects, and shares information when you use our websites, portals, applications, support tools, hosting services, or related services.</p>
                    <p>This policy applies to users, company administrators, client contacts, support requesters, and visitors who interact with Powell Industries services.</p>

                    <h3>2. Information we collect</h3>
                    <p class="mb-0">We may collect the following types of information.</p>
                    <p class="text-primary">Note: Any and all of this information can be deleted by request at any time. Complete a data deletion request by clicking <a href="#" class="text-white text-underline">here</a>.</p>

                    <h4>Account Information</h4>
                    <p>This may include:</p>
                    <ul>
                        <li>Name</li>
                        <li>Preferred Name</li>
                        <li>E-mail Address(es)</li>
                        <li>Phone Number(s)</li>
                        <li>Company Name(s)</li>
                        <li>Job Title(s)</li>
                        <li>Department(s)</li>
                        <li>User role(s)</li>
                        <li>Login Credentials</li>
                        <li>Account Status(es)</li>
                        <li>Profile Picture (if uploaded by you)</li>
                    </ul>

                    <h4>Company Information</h4>
                    <p>This may include:</p>
                    <ul>
                        <li>Company Name(s)</li>
                        <li>Business Address(es)</li>
                        <li>Contact Information</li>
                        <li>Domains</li>
                        <li>Services Used</li>
                        <li>Company User(s)</li>
                        <li>Billing Contacts</li>
                        <li>Supported Contacts</li>
                        <li>Legal or administrative business details that your organization provides</li>
                    </ul>

                    <h4>Portal and Service Information</h4>
                    <p>This may include:</p>
                    <ul>
                        <li>Products or services connected to your account</li>
                        <li>Hosting Records</li>
                        <li>Domain Records</li>
                        <li>Support Requests</li>
                        <li>Notifications</li>
                        <li>Preferences</li>
                        <li>Audit Logs</li>
                        <li>Platform Activity</li>
                        <li>Configuration Settings</li>
                    </ul>

                    <h4>Billing Information</h4>
                    <p>This may include:</p>
                    <ul>
                        <li>Invoices</li>
                        <li>Receipts</li>
                        <li>Payment Status(es)</li>
                        <li>Billing Contact Details</li>
                        <li>Service Charges</li>
                        <li>Transaction References</li>
                    </ul>

                    <p>We may use third-party processors (currently Stripe), and we do NOT store full payment card details ourselves.</p>

                    <h4>Technical Information</h4>
                    <p>When you use our websites, platforms and/or services, we may collect technical information such as:</p>
                    <ul>
                        <li>IP Address (used for your security and audit logs to be provided to you)</li>
                        <li>Browser Type (for UI styling that is implemented differently across browsers)</li>
                        <li>Device Type (to display either mobile layouts or desktop layouts)</li>
                        <li>Operating System (to debug our websites, platforms and/or services to avoid interruptions)</li>
                        <li>Pages Visited (to quickly redirect you where you left off in the previous session)</li>
                        <li>Login Timestamps (to ensure suspicious logins to your portal are legitimate)</li>
                        <li>Error Logs (to debug our websites, platforms and/or services to avoid interuptions)</li>
                        <li>Security Logs (to ensure suspicious activity can be identified to protect your data)</li>
                        <li>Session Data (to determine how you use our websites, platforms and/or services to improve your experience)</li>
                        <li>Approximate location based on IP address (to ensure suspicious activity can be located to protect your data)</li>
                    </ul>
                    <p>This helps us secure the platform, troubleshoot problems, and improve reliability, security and authenticity.</p>

                    <h3>3. How we use information</h3>
                    <p>We use information to:</p>
                    <ul>
                        <li>Create and Manage Accounts</li>
                        <li>Provide Access to PI | Portal, PI | Index, and Related Services</li>
                        <li>Manage Company Records and User Permissions</li>
                        <li>Provide Support</li>
                        <li>Process Billing</li>
                        <li>Send Important Account, Service, Security, and Legal Notices</li>
                        <li>Maintain Platform Security</li>
                        <li>Prevent Fraud, Abuse, and Unauthorized Access</li>
                        <li>Troubleshoot Errors</li>
                        <li>Improve Services</li>
                        <li>Company With Legal Obligations</li>
                        <li>Enforce Our Terms of Service</li>
                    </ul>
                    <p>We try to use information in ways that are practical, expected, transparent, and tied to the services we provide.</p>

                    <h3>4. How we do NOT use information</h3>
                    <p>We do NOT sell your personal information.</p>
                    <p>We do NOT rent your personal information.</p>
                    <p>We do NOT use your business records to advertise unrelated products to you.</p>
                    <p>We do NOT intentionally collect more data than we need to operate and support the platform.</p>
                    <p>We do NOT want to be creepy. That is NOT the business model.</p>

                    <h3>5. Cookies and similar technologies</h3>
                    <p>We may use cookies, local storage, session storage, or similar technologies for basic site and platform functionality.</p>
                    <p>These may help us:</p>
                    <ul>
                        <li>Keep Users Logged In</li>
                        <li>Remember Preferences</li>
                        <li>Protect Accounts</li>
                        <li>Improve Performance</li>
                        <li>Understand Basic Usage</li>
                        <li>Prevent Abuse</li>
                    </ul>
                    <p>If we use analytics, we prefere privacy-conscious analytics where possible.</p>
                    <p>We do not (and will never) use cookies for third-party ad tracking.</p>

                    <h3>6. Authentication and security</h3>
                    <p>We may use login credentials, secure cookies, session tokens, refresh tokens, multi-factor authentication, access controls, role-based permissions, and security logs to protect accounts.</p>
                    <p>You are responsible for keeping your account credentials secure and reporting suspicious activity.</p>

                    <h3>7. How we share information</h3>
                    <p>We may share information only when reasonably necessary, such as with:</p>
                    <ul>
                        <li>Service providers who help operate the platform</li>
                        <li>Hosting Providers</li>
                        <li>Domain Registrars</li>
                        <li>E-mail Providers</li>
                        <li>Payment Processors</li>
                        <li>Security Providers</li>
                        <li>Support Tools</li>
                        <li>Legal, Accounting, or Compliance Advisors</li>
                        <li>Governement or legal authorities when (and only if) required by law</li>
                    </ul>
                    <p>We do not share information just because someone asks. We review requests and respond according to law, security needs, and business obligation.</p>

                    <h3>8. Third-party providers</h3>
                    <p>Some parts of our services may rely on third-party providers. These providers may process certain information as needed to provide services.</p>
                    <p>Examples may include hosting, email delivery, payment processing, domain registration, logging, monitoring, security, or customer support tools.</p>
                    <p>We choose providers carefully, but their services may also be governed by their own terms and privacy policies.</p>

                    <h3>9. Data security</h3>
                    <p>We use reasonable technical and organizational safeguards to protect information.</p>
                    <p>These may include:</p>
                    <ul>
                        <li>Encryption in Transit</li>
                        <li>Encryption at rest where appropriate</li>
                        <li>Access Controls</li>
                        <li>Authentication</li>
                        <li>Role-based Permissions</li>
                        <li>Logging and Monitoring</li>
                        <li>Backups</li>
                        <li>Security Reviews</li>
                        <li>Limited Internal Access</li>
                    </ul>
                    <p>No system is perfect, but we take security seriously and aim to reduce risk wherever possible.</p>

                    <h3>10. Data retention</h3>
                    <p>We keep information for as long as needed to provide services, support customers, comply with law, resolve disputes, enforce agreements, maintain security, and operate the business.</p>
                    <p>Some records may be kept longer than others. For example:</p>
                    <ul>
                        <li>Account records may be kept while the account is active.</li>
                        <li>Support records may be kept for troubleshooting and service history.</li>
                        <li>Billing records may be kept for tax, accounting, and legal reasons.</li>
                        <li>Security logs may be kept to detect and investigate abuse.</li>
                        <li>When information is no longer needed, we will delete, archive, anonymize, or securely dispose of it where practical.</li>
                    </ul>

                    <h3>11. Your choices and rights</h3>
                    <p>You will ALWAYS have the choice to:</p>
                    <ul>
                        <li>Access your information</li>
                        <li>Correct inaccurate information</li>
                        <li>Request deletion</li>
                        <li>Request export of certain data</li>
                        <li>Object to certain uses</li>
                        <li>Limit certain processing</li>
                        <li>Close your account</li>
                    </ul>

                    <h3>12. Data export</h3>
                    <p>We believe customers should be able to access their own data.</p>
                    <p>Where technically and legally possible, you may request an export of your company or account data.</p>
                    <p>We may need to verify your identity and authority before providing an export.</p>

                    <h3>13. Data deletion</h3>
                    <p>You may request deletion of certain information. We will honor valid requests where legally and technically possible.</p>
                    <p>We may keep some information when required or allowed for:</p>
                    <ul>
                        <li>Billing</li>
                        <li>Tax Records</li>
                        <li>Legal Compliance</li>
                        <li>Security Investigations</li>
                        <li>Fraud Prevention</li>
                        <li>Backup Recovery</li>
                        <li>Dispute Resolution</li>
                        <li>Enforcement of Agreements</li>
                    </ul>

                    <h3>14. Children's privacy</h3>
                    <p>Our services are not intended for children under 13, and we do not knowingly collect personal information from children under 13.</p>
                    <p>Our services are generally intended for business and professional use by adults.</p>

                    <h3>15. Business customers and company administrators</h3>
                    <p>If your account is connected to a company, your company administrator may be able to view or manage certain account information, including your name, email, role, activity, service access, and support-related information.</p>
                    <p>If you use the platform through your employer, client, or organization, that organization may control parts of your access.</p>

                    <h3>16. Internation users</h3>
                    <p>Powell Industries is based in the United States. If you access our services from outside the United States, your information may be processed in the United States or other locations where our providers operate.</p>
                    <p>By using the services, you understand that privacy laws may differ from those in your location.</p>

                    <h3>17. Data breach response</h3>
                    <p>If we discover a security incident that affects personal information, we will investigate, take reasonable steps to reduce harm, and notify affected users or authorities when required by law.</p>

                    <h3>18. Changes to this policy</h3>
                    <p>We may update this Privacy Policy from time to time.</p>
                    <p>If we make material changes, we will try to notify users through the platform, by email, or through another reasonable method.</p>
                    <p>The updated policy will apply after it becomes effective.</p>

                    <h3>19. Contact</h3>
                    <p>Questions or requests about privacy can be sent to:</p>
                    <h4 class="mb-0">Powell Industries Inc.</h4>
                    <p class="mb-0">E-mail: privacy@powellii.com</p>
                    <p class="mb-0">Phone: +1 (404) 964-6847</p>
                    <p>Address: 100 Piedmont Avenue NE Atlanta, GA 30303</p>
                </div>
            </div>
        </div>
    </div>

    <app-footer-section></app-footer-section>
</section>